import React from "react";

const CloseButtonIcon = ({ size = 32, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="5 5 22 22"
    fill="none"
    {...props}
  >
    <path
      d="M12.1113 19.8906L19.8895 12.1125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8895 19.8915L12.1113 12.1133"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloseButtonIcon;
